import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { BillingInformation, EndOrderDetails, Order } from '@pedix-workspace/utils';

import { TranslocoDirective } from '@ngneat/transloco';
import {
  generateVoucher,
  arcaVatConditionOptions,
  arcaEntityTypeOptions,
  arcaDocumentTypeOptions,
} from '@pedix-workspace/integrations-arca';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { OrderDetailsTaxVoucherActionsComponent } from './order-details-tax-voucher-actions/order-details-tax-voucher-actions.component';
import { EnvironmentService } from '@pedix-workspace/angular-utils';

export type OrderListDetailRenderEvent = {
  row: Order;
  height: number;
};

@Component({
  selector: 'pxw-order-details-billing',
  templateUrl: './order-details-billing.component.html',
  styleUrls: ['./order-details-billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective, ButtonComponent, OrderDetailsTaxVoucherActionsComponent],
})
export class OrderDetailsBillingComponent {
  private environmentService = inject(EnvironmentService);

  readonly orderDetails = input.required<EndOrderDetails>();
  readonly billingInformation = input.required<BillingInformation | null | undefined>();

  readonly adminMode = input(false);

  readonly generatingTaxVoucher = signal(false);

  readonly taxVoucherId = computed(() => this.orderDetails().taxVoucher?.id);
  readonly taxVoucherBilled = computed(() => this.orderDetails().taxVoucher?.operation === 'bill');

  readonly billingEntity = computed(() => {
    const billingInformation = this.billingInformation();

    return (
      arcaEntityTypeOptions.find(option => option.id === billingInformation?.entityType)?.name ||
      '--'
    );
  });
  readonly vatCondition = computed(() => {
    const billingInformation = this.billingInformation();

    return (
      arcaVatConditionOptions.find(option => option.id === billingInformation?.vatCondition)
        ?.name || '--'
    );
  });
  readonly documentType = computed(() => {
    const billingInformation = this.billingInformation();

    return (
      arcaDocumentTypeOptions.find(option => option.id === billingInformation?.documentType)
        ?.name || '--'
    );
  });

  async onGenerateTaxVoucher() {
    this.generatingTaxVoucher.set(true);

    try {
      const { taxVoucher } = await generateVoucher(this.environmentService.apiIntegrationsUrl, {
        establishmentId: this.orderDetails().establishmentId,
        orderId: this.orderDetails().id!,
      });

      console.log(taxVoucher);
    } catch (error) {
      console.error(error);
    }

    this.generatingTaxVoucher.set(false);
  }
}
